<div data-cy="mb-clipboard-popup">
  <span>{{'pdpProductLine.orderNoWasCopiedToYourClipboard' | mbTranslate}}</span>
</div>
